/** Única compuerta del login de prod: encendida al certificar 153 y 019 (documento `raiz`, /sistema/inicio con ReturnUrl). */
export const LOGIN_PROD_ACTIVO = true;
export const RUTA_LOGIN = LOGIN_PROD_ACTIVO ? '/sistema/inicio' : '/login';
export const PARAM_REGRESO = LOGIN_PROD_ACTIVO ? 'ReturnUrl' : 'returnTo';
export function urlLogin(regreso?: string | null): string {
  return regreso ? `${RUTA_LOGIN}?${PARAM_REGRESO}=${encodeURIComponent(regreso)}` : RUTA_LOGIN;
}
